var map = {
	"./Human_symbol_0.png": 69641,
	"./Human_symbol_1.png": 45440,
	"./Human_symbol_2.png": 26651,
	"./Human_symbol_3.png": 5106,
	"./Human_symbol_4.png": 51437,
	"./Human_symbol_5.png": 71844,
	"./Human_symbol_6.png": 73471,
	"./Human_symbol_7.png": 19670,
	"./Human_symbol_8.png": 58449,
	"./Human_symbol_9.png": 10056
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 83840;